import React from 'react';
import { Bar } from '@ant-design/plots';

const Mostdownloaded = (props) => {
  const data = []
  props?.totalTopDownload.forEach(element => {
    data.push({
      Email:element.position,
      Downloads:parseInt(element.downloads),
    })
  });

  if(data.length>0){
    const config = {
      data,
      minBarWidth: 15,
      maxBarWidth: 15,
      height:230,
      seriesField: 'type', // or seriesField in some cases
      color: ['red', '#2ca02c', '#000000'],
      xField: 'Downloads',
      yField: 'Email',
      xAxis: { label: { autoHide: true, autoRotate: false } } ,
      barStyle: {
        radius: [20, 20, 20, 20],
        width:10,
        lineWidth:1,
        fill:"#2CDDC7"
      },
      scrollbar: {
        type: 'vertical',
        style: {
          trackColor: '#F0FAFF',
          thumbColor: '#D7F2FF'
        },
      },
      tooltip: {
        showTitle: false,
        fields: ['Email', 'Downloads'],
      }
    };
    return <Bar {...config} />;
  }

};

export default Mostdownloaded;
